
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Watch} from 'vue-property-decorator';
  import ChallengeItem from './ChallengeItem.vue';
  import SectionLayout from '../../SectionLayout.vue';
  import {inProgressChallengesModule, inProgressChallengesState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import {navLightTheme} from '@/components/NavBar/navbar-theme';

  @Component({
    components: {
      ChallengeItem,
      SectionLayout,
    },
  })
  export default class HomeChallenges extends Vue {
    hasSeveralChallenges: boolean = false;

    @inProgressChallengesModule.Getter('homeChallenges') challenges!: ChallengeModel[];

    mounted() {
      this.beforeEnter();
    }

    animate(direction: string) {
      const {challengeZero, challengeOne} = this.$refs;
      if (challengeZero && challengeOne) {
        // @ts-ignore
        challengeZero.animate(direction);
        // @ts-ignore
        challengeOne.animate(direction);
      }
    }

    @Watch('$router')
    beforeEnter() {
      inProgressChallengesState.fetchAll({page: 1})
    }
  }
